import Mutations from '../../odata/mutations';

export default { ...new Mutations('presenter'), ...new Mutations('presenters') };
